import { StyledHelpIcon } from '../FormGroup.styled';
import TooltipMF from '../TooltipMF';
import { HelpTooltipProps } from './HelpTooltip.types';

export const HelpTooltip: React.FC<HelpTooltipProps> = ({ message }) => {
  return (
    <TooltipMF content={message} type="full-content" direction="up">
      <StyledHelpIcon />
    </TooltipMF>
  );
};
